'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Compile;
// @see https://docs.angularjs.org/api/ng/service/$compile
function Compile($injector) {
    var $compile = $injector.get('$compile');

    return {
        transclude: true,
        link: function link(scope, element, attrs, controller, transcludeFn) {
            var unbindWatcher = scope.$watch(function (scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            }, function (value) {
                if (false === value) {
                    // use the default tag content
                    transcludeFn(scope, function (clone) {
                        element.append(clone);
                    });
                    return;
                }
                // when the 'compile' expression changes assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current scope.
                $compile(element.contents())(scope);

                if (attrs.compileOnce == 'true') {
                    unbindWatcher();
                }
            });
        }
    };
}

Compile.$inject = ['$injector'];
module.exports = exports['default'];
//# sourceMappingURL=Compile.js.map


// WEBPACK FOOTER //
// ./~/ng-admin/lib/javascripts/ng-admin/Crud/misc/Compile.js